import { apiGet, apiSend } from './client';
import type { AdminUserRecord, UserRole } from './types';

export interface AdminUserUpdatePayload {
  role: UserRole;
  isBanned: boolean;
  banReason?: string | null;
}

export async function fetchAdminUsers() {
  const data = await apiGet<{ users: AdminUserRecord[] }>('/admin/users');
  return data.users;
}

export async function updateAdminUser(id: string, payload: AdminUserUpdatePayload) {
  const data = await apiSend<{ user: AdminUserRecord }>(`/admin/users/${id}`, 'PUT', payload);
  return data.user;
}
